import { render, staticRenderFns } from "./PageResolver.vue?vue&type=template&id=03a987d6"
import script from "./PageResolver.vue?vue&type=script&lang=js"
export * from "./PageResolver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports